export const SearchableLanguages = [
  "ar",
  "bn",
  "bn",
  "bg",
  "ca",
  "zh_Hans",
  "zh_Hant",
  "hr",
  "cs",
  "da",
  "nl",
  "en",
  "et",
  "fi",
  "fr",
  "gl",
  "de",
  "el",
  "gu",
  "he",
  "hi",
  "hu",
  "is",
  "id",
  "it",
  "ja",
  "kn",
  "ko",
  "lv",
  "lt",
  "ml",
  "ms",
  "mr",
  "nb",
  "fa",
  "pl",
  "pt",
  "pa",
  "ro",
  "ru",
  "sk",
  "sl",
  "es",
  "sv",
  "ta",
  "te",
  "th",
  "tr",
  "uk",
  "ur",
  "vi"
];
